import { IDevices } from 'components/UserMedia/helpers/enumerateDevices/IEnumerateDevices';

export enum EUserMediaEvent {
  MEDIA_DEVICES_UPDATED,
}

export type TUserMediaEvents = {
  [EUserMediaEvent.MEDIA_DEVICES_UPDATED]: CustomEvent<IDevices>;
};
